import type { PLCPaginationDTO } from '@/models/dto/plc/plc-pagination-dto'
import type { PLCsWithPagination } from '@/models/types/plc/plcs-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToBasePLC, mapToPLCBaseDTO } from './base-plc-mapper'

const mapToPLCsDTO = (plcs: PLCsWithPagination): PLCPaginationDTO => {
  return {
    plc: plcs.plcs?.map(mapToPLCBaseDTO) ?? null,
    paginationData: plcs.pagination ? mapToPaginationDTO(plcs.pagination) : null,
  }
}

const mapToPLCs = (dto: PLCPaginationDTO): PLCsWithPagination => {
  return {
    plcs: dto.plc?.map(mapToBasePLC) ?? undefined,
    pagination: dto.paginationData ? mapToPagination(dto.paginationData) : undefined,
  }
}

export { mapToPLCs, mapToPLCsDTO }
